import "./Header.css";
import i18n from "../i18n";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { GcdsSearch, GcdsTopicMenu } from "@cdssnc/gcds-components-react";
import { useDispatch, useSelector } from "react-redux";
import { currentLanguage } from "../../Redux/SetUserLanguage";

const languageChange = (dispatch, AT) => {
  let userLocaleSettings = localStorage.getItem("locale");
  document.documentElement.setAttribute("lang", userLocaleSettings);

  if (userLocaleSettings === "en") {
    localStorage.setItem("locale", "fr");
    i18n.changeLanguage("fr");
    dispatch(currentLanguage("fr"));
    document.documentElement.setAttribute("lang", "fr");
  } else {
    localStorage.setItem("locale", "en");
    i18n.changeLanguage("en");
    dispatch(currentLanguage("en"));
    document.documentElement.setAttribute("lang", "en");
  }

  const enMenu = document.querySelector('gcds-topic-menu[lang="en"]');
  const frMenu = document.querySelector('gcds-topic-menu[lang="fr"]');
  let enMenuButton = enMenu.shadowRoot.querySelector("button");
  let frMenuButton = frMenu.shadowRoot.querySelector("button");
  if (enMenuButton.getAttribute("aria-expanded") === "true") {
    enMenuButton.click();
  }

  if (frMenuButton.getAttribute("aria-expanded") === "true") {
    frMenuButton.click();
  }
};

const Header = ({ shouldShow }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();

  const currentLocale = localStorage.getItem("locale");

  const { applicationTitle } = useSelector((state) => state.applicationTitle);
  window.document.title = t(applicationTitle);

  if (location.pathname === "/") {
    return;
  }

  return (
    <div>
      <html class="no-js" lang={currentLocale} dir="ltr">
        <head>
          <meta charSet="utf-8" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta name="description" content=" " />
          <link
            href="https://wet-boew.github.io/themes-dist/GCWeb/GCWeb/assets/favicon.ico"
            rel="icon"
            type="image/x-icon"
          />
          <link
            rel="stylesheet"
            href="https://wet-boew.github.io/themes-dist/GCWeb/GCWeb/css/theme.min.css"
          />
        </head>
        <body vocab="https://schema.org/" typeof="WebPage">
          <nav>
            <ul id="wb-tphp">
              <li class="wb-slc">
                <a class="wb-sl" href="#wb-cont">
                  {t("header.skipContent")}
                </a>
              </li>
              <li class="wb-slc">
                <a class="wb-sl" href="#wb-info">
                  {t("header.skipAbout")}
                </a>
              </li>
            </ul>
          </nav>

          <header>
            <div id="wb-bnr" class="container">
              <div class="row">
                <section
                  id="wb-lng"
                  class="col-xs-3 col-sm-12 pull-right text-right"
                >
                  <ul class="list-inline mrgn-bttm-0">
                    <li>
                      <button
                        title={
                          currentLocale === "fr"
                            ? t("GovernmentOfCanadaMenu.en")
                            : t("GovernmentOfCanadaMenu.fr")
                        }
                        aria-label={
                          currentLocale === "fr"
                            ? t("GovernmentOfCanadaMenu.en")
                            : t("GovernmentOfCanadaMenu.fr")
                        }
                        className="headerLngButton"
                        lang={
                          currentLocale === "fr"
                            ? t("GovernmentOfCanadaMenu.en")
                            : t("GovernmentOfCanadaMenu.fr")
                        }
                        onClick={() =>
                          languageChange(dispatch, applicationTitle)
                        }
                      >
                        <span class="hidden-xs">
                          {currentLocale === "fr"
                            ? t("GovernmentOfCanadaMenu.en")
                            : t("GovernmentOfCanadaMenu.fr")}
                        </span>
                        <span className="visible-xs">
                          {currentLocale === "fr"
                            ? t("GovernmentOfCanadaMenu.enShort")
                            : t("GovernmentOfCanadaMenu.frShort")}
                        </span>
                        <abbr
                          title={
                            currentLocale === "fr"
                              ? t("GovernmentOfCanadaMenu.en")
                              : t("GovernmentOfCanadaMenu.fr")
                          }
                          class="visible-xs h3 mrgn-tp-sm mrgn-bttm-0 text-uppercase"
                        ></abbr>
                      </button>
                    </li>
                  </ul>
                </section>

                <div
                  class="brand col-xs-9 col-sm-5 col-md-4 text-left"
                  property="publisher"
                  typeof="GovernmentOrganization"
                >
                  <a href="https://www.canada.ca/en.html" property="url">
                    <img
                      src="https://wet-boew.github.io/themes-dist/GCWeb/GCWeb/assets/sig-blk-en.svg"
                      alt="Government of Canada"
                      property="logo"
                    />
                    <span class="wb-inv">
                      / <span lang="fr">Gouvernement du Canada</span>
                    </span>
                  </a>
                  <meta property="name" content="Government of Canada" />
                  <meta
                    property="areaServed"
                    typeof="Country"
                    content="Canada"
                  />
                  <link
                    property="logo"
                    href="https://wet-boew.github.io/themes-dist/GCWeb/GCWeb/assets/wmms-blk.svg"
                  />
                </div>

                <section
                  id="wb-srch"
                  class="col-lg-offset-4 col-md-offset-4 col-sm-offset-2 col-xs-12 col-sm-5 col-md-4"
                >
                  {currentLocale === "en" ? <GcdsSearch lang={"en"} /> : ""}
                  {currentLocale === "fr" ? <GcdsSearch lang={"fr"} /> : ""}
                </section>
              </div>
            </div>
            <hr />
            <div className="menuContainer">
              <div className={currentLocale === "fr" ? null : "hiddenMenu"}>
                <GcdsTopicMenu lang={"fr"}></GcdsTopicMenu>
              </div>
              <div className={currentLocale === "en" ? null : "hiddenMenu"}>
                <GcdsTopicMenu lang={"en"}></GcdsTopicMenu>
              </div>
            </div>
          </header>
          <script src="https://ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.js"></script>
          <script src="https://wet-boew.github.io/themes-dist/GCWeb/wet-boew/js/wet-boew.min.js"></script>
          <script src="https://wet-boew.github.io/themes-dist/GCWeb/GCWeb/js/theme.min.js"></script>
        </body>
      </html>
    </div>
  );
};

export default Header;
